const config = {
  baseURL: "http://localhost:8006/api",
  //baseURL: "https://easygest.co/api",
  crossOrigin: null,
  basename: '/'
};
export default config;
